const OtherSocialIcon = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="#fb3973"
    >
      <path d="m128 24a104 104 0 1 0 104 104 104.11791 104.11791 0 0 0 -104-104zm0 192a88 88 0 1 1 88-88 88.09957 88.09957 0 0 1 -88 88zm12-88a12 12 0 1 1 -12-12 12.01375 12.01375 0 0 1 12 12zm48 0a12 12 0 1 1 -12-12 12.01375 12.01375 0 0 1 12 12zm-96 0a12 12 0 1 1 -12-12 12.01375 12.01375 0 0 1 12 12z" />
    </svg>
  );
};

export default OtherSocialIcon;
